import React, { useState, useEffect } from "react";
import BasicTable from "../../Components/Table/Material";
import { usePagination } from "../../Hooks/usePagination";
import Common from "../../Components/Layouts/Common";
import { useModal } from "../../Hooks/useModal";
import Modal from "../../Components/Modal";
import IMISDataInsertionModal from "../../Components/Modal/IMISDataInsertionModal";
import useWindowWidth from "../../Hooks/useWindowWidth";
import useApi from "../../Hooks/useApi";
import { fetchIMISCityData } from "../../Utils/imisCityDashboardUtils";

const IMISDashboardManagment = () => {
  const paginateProps = usePagination();
  const [data, setData] = useState([]);
  const [selectedRow, setSelectedRow] = useState({});
  const { isOpen, closeModal, openModal } = useModal();

  const { request } = useApi();
  const windowWidth = useWindowWidth();

  const handleView = (row) => {
    openModal();
    setSelectedRow({ ...row, year: row.year, status: row.status });
  };

  const columns = [
    {
      id: "city",
      label: "City",
      minWidth: 100,
    },
    {
      id: "year",
      label: "Year",
      minWidth: 100,
    },
    {
      id: "uploader",
      label: "Uploader",
      minWidth: 170,
    },
    {
      id: "uploaderDate",
      label: "Uploaded Date",
      minWidth: 100,
    },
    {
      id: "status",
      label: "Status",
      minWidth: 100,
    },

    {
      id: "action",
      label: "Action",
      minWidth: 170,
      align:"center",
      renderCell: (row, rowIndex) => {
        return (
      <div className="flex justify-center">
  <button
    onClick={(e) => handleView(row)}
    className={`bg-[#1976d2] border border-gray-300 p-2 px-8 text-white rounded-md flex items-center justify-center cursor-pointer `}
  >
    View {row.status !== "PUBLISHED" ? "and Publish" : ""}
  </button>
</div>
        );
      },
    },
  ];

  useEffect(() => {
    const fetchCityYearListData = async () => {
      try {
        await fetchIMISCityData(request, setData);
      } catch (error) {
        console.log(error);
      }
    };

    fetchCityYearListData();
  }, [request]);

  return (
    <Common headline={"IMIS Dashboard"}>
      <BasicTable
        columns={columns}
        data={data}
        paginateProps={paginateProps}
        maxHeight={15000}
      />

      <Modal
        isOpen={isOpen}
        onClose={closeModal}
        style={{ width: windowWidth >= 768 ? "70vw" : "90vw" }}
      >
        <IMISDataInsertionModal imis={selectedRow} onClose={closeModal} />
      </Modal>
    </Common>
  );
};

export default IMISDashboardManagment;
